import React, { Component } from 'react';
import * as Yup from 'yup';
import { FormInput, FormTextArea } from '../../common';
import { Formik } from 'formik';
import {
  Button,
  Form,
  Grid,
  Header,
  Message,
  Segment,
  Label
} from 'semantic-ui-react';
import { messages } from '../../../utils';

const { validation } = messages;

class ContactUs extends Component {

  onSubmitBtnClick(values,resetForm) {
    const { handleSubmitBtn } = this.props;
    handleSubmitBtn(values, resetForm);
  }
	render() {
    const { isLoading } = this.props;
		return (
      <div style={{marginTop: '10px'}}>
  <Grid centered columns={2}>
    <Grid.Column>
      <Header as="h2" textAlign="center">
        Contact Us
      </Header>
     
      <Segment>
        <Form size="large">
          <Formik
            initialValues={{ name:'', email:'', subject:'', message:'' }}
            onSubmit={(values, { resetForm }) => {
            this.onSubmitBtnClick(values,resetForm);
        }
        }
            validationSchema={
              Yup.object().shape({
                name: Yup.string().min(3, 'At-least 3 characters are require').max(100, "Maximum characters exceed 100").required(validation.requiredField),
                email: Yup.string().email(validation.invalidEmail).max(100, "Maximum characters exceed 100").required(validation.requiredField),
                subject: Yup.string().min(3, 'At-least 3 characters are require').max(100, "Maximum characters exceed 100").required(validation.requiredField),
                message: Yup.string().min(10, 'At-least 10 characters are require').max(500, "Maximum characters exceed 500").required(validation.requiredField)
              })
            }
            render={({
              values,
              handleSubmit,
              setFieldValue,
              errors,
              touched,
            }) => (
              <div>
               
                <div className="row">
                  <div className="col-sm mt-4">
                  {errors.name && touched.name && <Label style={{marginTop:'5px'}}>
                      {errors.name}
                    </Label>}
                  <FormInput
                  style={{marginBottom:'10px'}}
                    fluid
                    value={values.name}
                    icon="lock"
                    iconPosition="left"
                    placeholder="name"
                    type="text"
                    name="name"
                    onChange={(event,data) => data && data.name ? setFieldValue(data.name, data.value): ''}
                    required
                  />
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm mt-4">
                  {errors.email && touched.email && <Label>
                      {errors.email}
                    </Label>}
                     <FormInput
                     style={{marginBottom:'10px'}}
                     value={values.email}
                     fluid
                      icon="user"
                      iconPosition="left"
                      placeholder="Email address"
                     onChange={(event,data) => data && data.name ? setFieldValue(data.name, data.value): ''}
                      required
                      name='email'
                      type='text'
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm mt-4">
                  {errors.subject && touched.subject && <Label style={{marginTop:'5px'}}>
                      {errors.subject}
                    </Label>}
                  <FormInput
                  style={{marginBottom:'10px'}}
                    fluid
                    value={values.subject}
                    icon="lock"
                    iconPosition="left"
                    placeholder="subject"
                    type="text"
                    name="subject"
                    onChange={(event,data) => data && data.name ? setFieldValue(data.name, data.value): ''}
                    required
                  />
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm mt-4">
                  {errors.message && touched.message && <Label style={{marginTop:'5px'}}>
                      {errors.message}
                    </Label>}
                  <FormTextArea
                  style={{marginBottom:'10px'}}
                    fluid
                    value={values.message}
                    icon="lock"
                    iconPosition="left"
                    placeholder="message"
                    type="text"
                    name="message"
                    onChange={(event,data) => data && data.name ? setFieldValue(data.name, data.value): ''}
                    required
                  />
                  </div>
                </div>

                <div className="row">
                
                  <div className="col-sm text-right">
                  <Button loading={isLoading} color="blue" type="submit" fluid size="large" onClick={() => handleSubmit(values)}>Submit</Button>
                  </div>
                </div>
                </div>
            )}
          />
        </Form>
      </Segment>
    </Grid.Column>
  </Grid>
      </div>
		);
	}
}

export default ContactUs;